module.exports = __webpack_public_path__ + "resources/img/img_secureguard_am5.1517c5535bce193ceaf152d558e25e53.png";